import PropTypes from 'prop-types';
import React from 'react';
import {DonorProfile} from "./DonorProfile.js";
import {PROJECTS_IN_PROGRESS_PAGE_COUNT} from "./donorProfileConstants.js";
import {FUNDED_PROJECTS_PAGE_COUNT} from "./donorProfileConstants.js";
import {loadingStatuses} from "./donorProfileConstants.js";
import { convertToApiURL } from '../common/searchRequestUtils.js';
import { Immutable } from '../../external/immutable.js';
import { isUserThisDonor } from '../utils/userUtils.js';

export class DonorProfileState extends React.PureComponent {
	constructor(props, context) {
		super(props, context);

		let viewingOwnPage = isUserThisDonor(props.data.id) && isLoggedInOrRemembered();

		const initialData = Immutable.Map().withMutations(function (map) {
			map.set("data", Immutable.fromJS(props.data))
					.set("viewingOwnPage", viewingOwnPage)
					.set("inProgressProjectsOffset", 0)
					.set("fundedProjectsOffset", 0)
					.set("projectsInProgressDonations", [])
					.set("fundedProjectDonations", [])
					.set("fundedProjects", [])
					.set("projectsInProgress", [])
					.set("loadingStatuses", Immutable.Map())
		});

		this.state = {map: initialData};
		this.setFundedProjects = this.setFundedProjects.bind(this);
		this.setProjectsInProgress = this.setProjectsInProgress.bind(this);
		this.setAndLoadProjectsInProgressDonations = this.setAndLoadProjectsInProgressDonations.bind(this);
		this.setAndLoadFundedProjectDonations = this.setAndLoadFundedProjectDonations.bind(this);
		this.showMoreFundedProjects = this.showMoreFundedProjects.bind(this);
		this.showMoreProjectsInProgress=this.showMoreProjectsInProgress.bind(this);
		this.setShowShareLightBox=this.setShowShareLightBox.bind(this);
	}

	componentDidMount() {
//		this should always be false for partner donors, but is also controlled by the donorGivingHistoryEnabled feature flag
		if(this.state.map.get("data").get("givingHistoryEnabled")) {
			this.setLoadingDonationsStatus(loadingStatuses.LOADING_IN_PROGRESS_DONATIONS, true);
			this.setLoadingDonationsStatus(loadingStatuses.LOADING_FULLY_FUNDED_DONATIONS, true);
			this.getRecentDonations(false, PROJECTS_IN_PROGRESS_PAGE_COUNT, 0, this.setAndLoadProjectsInProgressDonations);
			this.getRecentDonations(true, FUNDED_PROJECTS_PAGE_COUNT, 0, this.setAndLoadFundedProjectDonations);
		}
	}

	getRecentDonations(fullyFunded, count, offset, callback) {
		let component = this;
		let loadingDonationType = fullyFunded ? loadingStatuses.LOADING_FULLY_FUNDED_DONATIONS : loadingStatuses.LOADING_IN_PROGRESS_DONATIONS
		$.ajax({
			url: secureBaseURL + 'donors/get_recent_project_donations.html',
			method: "GET",
			data: {
				'donorId': component.state.map.get("data").get("id"),
				'count': count,
				'offset': offset,
				'fullyFunded': fullyFunded
			},
			dataType: 'json',
			xhrFields: {
				withCredentials: true
			},
		}).done((data) => {
			callback(data)
		}).fail((data) => {
			callback([])
		}).always((data) => {
			//these only get set to true on the initial load on mount
			this.setLoadingDonationsStatus(loadingDonationType, false);
		});
	}

	loadProjects(projects, callback, fullyFunded) {
		if (!projects || projects.length === 0) {
			return '';
		}
		let searchURL = baseURL + "donors/search.html?id=" + this.getProjectIds(projects) + '&sortBy=3';
		let loadingDonationType = fullyFunded ? loadingStatuses.LOADING_FULLY_FUNDED_PROJECTS : loadingStatuses.LOADING_IN_PROGRESS_PROJECTS
		this.setLoadingDonationsStatus(loadingDonationType, true);

		$.ajax({
			url: convertToApiURL(searchURL),
			method: "GET",
			cache: true,
			dataType: 'json',
		}).done((data) => {
			callback(data.proposals)
		}).fail((data) => {
			callback([])
		}).always((data) => {
			this.setLoadingDonationsStatus(loadingDonationType, false);
		});
	}

	setProjectsInProgress(data){
		this.setState((prevState) => {
			let projects = prevState.map.get("projectsInProgress").concat(data)
			var updatedState = prevState.map.set("projectsInProgress", projects);
			return {map: updatedState};
		});
	}

	setFundedProjects(data){
		//sorting projects descending by fully funded date so we can display them in order
		data.sort(function(a, b){return Date.parse(b.fullyFundedDate) - Date.parse(a.fullyFundedDate)})
		this.setState((prevState) => {
			let projects = prevState.map.get("fundedProjects").concat(data)
			var updatedState = prevState.map.set("fundedProjects", projects);
			return {map: updatedState};
		});
	}

	setAndLoadProjectsInProgressDonations(data){
		if (!data || data.length === 0) {
			this.setLoadingDonationsStatus(loadingStatuses.IN_PROGRESS_END_REACHED, true);
		}else {
			this.setProjectDonations("projectsInProgressDonations", data);
			this.loadProjects(data, this.setProjectsInProgress, false);
		}
	}

	setAndLoadFundedProjectDonations(data){
		if (!data || data.length === 0) {
			this.setLoadingDonationsStatus(loadingStatuses.FULLY_FUNDED_END_REACHED, true);
		}else {
			this.setProjectDonations("fundedProjectDonations", data);
			this.loadProjects(data, this.setFundedProjects, true);
		}
	}

	setProjectDonations(donationType, data){
		this.setState((prevState) => {
			let donations = prevState.map.get(donationType).concat(data)
			let updatedState = prevState.map.set(donationType, donations);
			return {map: updatedState};
		});
	}

	getProjectIds(donations) {
		if (donations.length === 0) {
			return '';
		}
		let projectIds = '';
		for (let i = 0; i < donations.length; i++) {
			projectIds += donations[i]['projectId'] + (i !== donations.length - 1 ? ',' : '');
		}
		return projectIds;
	}

	showMoreFundedProjects(){
		this.setState((prevState) => {
			let offset = prevState.map.get("fundedProjectsOffset")
			let updatedState = prevState.map.set("fundedProjectsOffset", offset + FUNDED_PROJECTS_PAGE_COUNT);
			return {map: updatedState};
		}, () => {
			this.getRecentDonations(true, FUNDED_PROJECTS_PAGE_COUNT, this.state.map.get("fundedProjectsOffset"), this.setAndLoadFundedProjectDonations);
		});
	}

	showMoreProjectsInProgress(){
		this.setState((prevState) => {
			let offset = prevState.map.get("inProgressProjectsOffset")
			let updatedState = prevState.map.set("inProgressProjectsOffset", offset + PROJECTS_IN_PROGRESS_PAGE_COUNT);
			return {map: updatedState};
		}, () => {
			this.getRecentDonations(false, PROJECTS_IN_PROGRESS_PAGE_COUNT, this.state.map.get("inProgressProjectsOffset"), this.setAndLoadProjectsInProgressDonations);
		});
	}

	setLoadingDonationsStatus(donationLoadingType, value){
		this.setState((prevState) => {
			var updatedStatusMap = prevState.map.get("loadingStatuses").set(donationLoadingType, value);
			var updatedState = prevState.map.set("loadingStatuses", updatedStatusMap);

			return {map: updatedState};
		});
	}

	setShowShareLightBox(showShareLightBox) {
		this.setState((prevState) => {
			let updatedState = prevState.map.set("showShareLightBox", showShareLightBox);
			return {map: updatedState};
		});
	}

	render() {
		let map = this.state.map.toJS();
		return (
				<DonorProfile
						donorData={map.data}
						projectsInProgressDonations={map.projectsInProgressDonations}
						projectsInProgress={map.projectsInProgress}
						fundedProjectDonations={map.fundedProjectDonations}
						fundedProjects={map.fundedProjects}
						viewingOwnPage={map.viewingOwnPage}
						loadingStatuses={map.loadingStatuses}
						showShareLightBox={map.showShareLightBox}
						showMoreFundedProjects = {this.showMoreFundedProjects}
						showMoreProjectsInProgress = {this.showMoreProjectsInProgress}
						setShowShareLightBox={this.setShowShareLightBox}
				/>
		);
	}
}

DonorProfileState.propTypes = {
	data: PropTypes.object
};
